/* Load storefront modules when their component is present, including section API results. */
(() => {
  const selectors = {
    'popover-polyfill.js': '[popover]',
    'overflow-list.js': 'overflow-list',
    'quick-add.js': 'quick-add-component, product-card',
    'cart-discount.js': 'cart-discount-component',
    'dialog.js': 'dialog-component',
    'variant-picker.js': 'variant-picker',
    'product-card.js': 'product-card, product-card-link, swatches-variant-picker-component',
    'product-form.js': 'product-form-component, add-to-cart-component',
    'fly-to-cart.js': 'fly-to-cart',
    'accordion-custom.js': 'accordion-custom',
    'media.js': 'deferred-media, product-model',
    'product-price.js': 'product-price',
    'product-sku.js': 'product-sku-component',
    'product-title-truncation.js': 'product-title',
    'product-inventory.js': 'product-inventory',
    'show-more.js': 'show-more-component',
    'slideshow.js': 'slideshow-component',
    'layered-slideshow.js': 'layered-slideshow-component',
    'anchored-popover.js': 'anchored-popover-component',
    'floating-panel.js': 'floating-panel-component',
    'video-background.js': 'video-background-component',
    'component-quantity-selector.js': 'quantity-selector-component',
    'media-gallery.js': 'media-gallery, quick-add-component',
    'rte-formatter.js': 'rte-formatter',
    'volume-pricing.js': 'volume-pricing',
    'price-per-item.js': 'price-per-item',
    'volume-pricing-info.js': 'volume-pricing-info',
    'localization.js': 'localization-form-component, dropdown-localization-component, drawer-localization-component',
  };
  const pending = Array.from(document.querySelectorAll('script[data-bm-module]')).map(node => ({
    node,
    selector: selectors[new URL(node.getAttribute('src'), document.baseURI).pathname.split('/').pop()],
  }));
  const loading = [];
  function loadModules(root) {
    for (let index = pending.length - 1; index >= 0; index--) {
      const entry = pending[index];
      if (entry.selector && !(root.matches?.(entry.selector) || root.querySelector?.(entry.selector))) continue;
      loading.push(import(entry.node.getAttribute('src')));
      entry.node.remove();
      pending.splice(index, 1);
    }
    return Promise.all(loading);
  }
  window.bmLoadModules = loadModules;
  loadModules(document).catch(console.error);
  if (!pending.length) return;
  const observer = new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === Node.ELEMENT_NODE) loadModules(node).catch(console.error);
      }
    }
    if (!pending.length) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
